import { Navigate, useParams, useSearchParams } from 'react-router-dom';

// Old integration addresses (bookmarks, e-mails, other screens) → the one page per integration.
// See notes/ux-integrations-vendeur.md §4.6 (Routes).

/** /integrations/setup?template=<id>&step=<n> → /integrations/<id>?tab=installation */
export const LegacySetupRedirect = () => {
    const [searchParams] = useSearchParams();
    const templateId = searchParams.get('template');
    if (!templateId) return <Navigate to="/integrations" replace />;
    // The old wizard's steps 2-3 (pixel, iframe) are now "Installer", step 4 "Vos prix".
    const step = searchParams.get('step') === '4' ? 'prices' : searchParams.get('step') ? 'install' : null;
    return <Navigate to={`/integrations/${templateId}?tab=installation${step ? `&step=${step}` : ''}`} replace />;
};

/** /integrations/edit/<id>?tab=<old tab> → /integrations/<id>?tab=<old tab> (mapped by the page) */
export const LegacyEditRedirect = () => {
    const { id } = useParams<{ id: string }>();
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab');
    return <Navigate to={`/integrations/${id}${tab ? `?tab=${tab}` : ''}`} replace />;
};
